import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import EventsSection from "./components/EventsSection";
import SeasonsSection from "./components/SeasonsSection";
import Calculator from "./components/AdvancedCalculator";
import DualCalculatorsNav from "./components/DualCalculatorsNav";
import PackagesSection from "./components/PackagesSection";
import HowToUse from "./components/HowToUse";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import FeedbackSection from "./components/FeedbackSection";
import DualCharactersPage from "./pages/DualCharactersPage";
import DualWeaponsPage from "./pages/DualWeaponsPage";
import SuggestionsPage from "./pages/SuggestionsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AuthCallback from "./pages/AuthCallback";
import AdminSuggestionsPage from "./pages/AdminSuggestionsPage";
import AdminEventsPage from "./pages/AdminEventsPage";
import AdminSeasonsPage from "./pages/AdminSeasonsPage";
import AdminSyncPage from "./pages/AdminSyncPage";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import { EventsProvider } from "./contexts/EventsContext";
import CPCoinsLayer from "./components/CPCoinsLayer";
import WelcomeIntro from "./components/WelcomeIntro";
import AudioToggle from "./components/AudioToggle";
import RushAIChat from "./components/RushAIChat";
import { isInteractiveLayerEnabled } from "./lib/featureFlags";

const HomePage = () => {
  const [introDone, setIntroDone] = useState(false);
  const showInteractive = isInteractiveLayerEnabled();
  return (
    <div className="App min-h-screen bg-[#0A1128] text-white overflow-x-hidden" dir="rtl">
      <div
        className="pointer-events-none fixed inset-0 opacity-[0.04] z-0"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />
      {/* الطبقات التفاعلية الجديدة — مُفعّلة فقط في Preview */}
      {showInteractive && <CPCoinsLayer />}
      {/* محتوى الموقع - z=10 */}
      <div className="relative z-10">
        <Header />
        <Hero />
        <EventsSection />
        <SeasonsSection />
        <Calculator />
        <DualCalculatorsNav />
        <PackagesSection />
        <HowToUse />
        <FAQ />
        <FeedbackSection />
        <Footer />
      </div>
      {showInteractive && <WelcomeIntro onDone={() => setIntroDone(true)} />}
      {showInteractive && <AudioToggle />}
      {showInteractive && <RushAIChat />}
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <EventsProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/dual-characters" element={<DualCharactersPage />} />
            <Route path="/dual-weapons" element={<DualWeaponsPage />} />
            <Route path="/suggestions" element={<SuggestionsPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/auth-callback" element={<AuthCallback />} />
            <Route path="/admin/suggestions" element={<AdminSuggestionsPage />} />
            <Route path="/admin/events" element={<AdminEventsPage />} />
            <Route path="/admin/seasons" element={<AdminSeasonsPage />} />
            <Route path="/admin/sync" element={<AdminSyncPage />} />
          </Routes>
        </EventsProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
